'use client';

import { Link } from '@/i18n/routing';
import { CheckCircle2, ExternalLink } from 'lucide-react';
import { useTranslations } from 'next-intl';

/**
 * Shown on `/pricing` when the professional-audience toggle is on. Explains
 * that claiming an existing registry-listed profile is free (no subscription
 * required) and links to the claim flow. Separate from the tier grid so it
 * doesn't compete for comparison with the paid SKUs.
 */
export function ClaimProfileFreeCard() {
  const t = useTranslations('PricingPage');
  return (
    <div className='mx-auto max-w-3xl rounded-2xl border border-line-default bg-gradient-to-br from-status-success/5 via-surface-card to-brand-tertiary/5 px-6 py-5 shadow-sm'>
      <div className='flex items-start gap-4'>
        <div className='flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-status-success/15 text-status-success'>
          <CheckCircle2 className='h-5 w-5' aria-hidden='true' />
        </div>
        <div className='flex flex-1 flex-col gap-1'>
          <p className='text-sm font-semibold text-content-primary'>
            {t('claimProfileFreeTitle')}
          </p>
          <p className='text-sm text-content-secondary'>
            {t('claimProfileFreeDescription')}
          </p>
          <Link
            href='/advokati'
            className='mt-1 inline-flex items-center gap-1 text-sm font-medium text-brand-tertiary hover:text-brand-tertiary-hover'
          >
            {t('claimProfileFreeCta')}
            <ExternalLink className='h-3.5 w-3.5' aria-hidden='true' />
          </Link>
        </div>
      </div>
    </div>
  );
}
